import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Box
} from "@mui/material";
import { AppContext } from "helpers/context";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./event-detail.module.scss";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const EventDetails = () => {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();

  const [rows, setRows] = useState<any[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const convertToTableRows = (data: any) => {
    return [
      { key: "peril", value: data.name },
      { key: "type", value: data.type },
      {
        key: "Event Date",
        value: data.type === "Earthquake" ? `${dayjs(data.eventDateTime).utc().format('YYYY-MM-DD HH:mm:ss')} UTC` : dayjs(data.eventDateTime).tz('Asia/Shanghai').format('YYYY-MM-DD')
      },
      {
        key: "Last Update",
        value: data.type === "Earthquake" ? `${dayjs(data.updateDateTime).utc().format('YYYY-MM-DD HH:mm:ss')} UTC` : dayjs(data.updateDateTime).tz('Asia/Shanghai').format('YYYY-MM-DD')
      },
      {
        key: "Location",
        value: `${data.latitude}, ${data.longitude}`
      },
      { key: "Description", value: data.description },
      { key: "Source", value: data.source }
    ];
  };

  useEffect(() => {
    if (!context.selectedEvent) {
      setRows([]);
      return;
    }
    const newRows = convertToTableRows(context.selectedEvent);
    setRows(newRows);
  }, [context.selectedEvent]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          mt: 2,
          mb: 2
        }}
        style={{ marginRight: "0.75rem" }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Box sx={{ mr: 1 }}>
          {isExpanded ? (
            <Box
              sx={{
                display: "inline-block",
                transform: "rotate(0deg)",
                color: "green"
              }}
            >
              ▼
            </Box>
          ) : (
            <Box
              sx={{
                display: "inline-block",
                transform: "rotate(270deg)",
                color: "green"
              }}
            >
              ▼
            </Box>
          )}
        </Box>
        <Typography className={styles.title}>
          {t("events.Event Details")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: isExpanded ? "block" : "none" // 控制内容的显示和隐藏
        }}
        style={{ marginRight: "0.75rem" }}
      >
        <Table
          sx={{
            border: "none",
            "& th": {
              border: "none"
            },
            "& td": {
              border: "none",
              fontSize: "12px",
              padding: "3px"
            }
          }}
        >
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.key}>
                <TableCell sx={{ color: "#0009", width: "30%" }}>
                  {t("events." + row.key)}:
                </TableCell>
                {index === 1 ? (
                  <TableCell>{t("events." + row.value)}</TableCell>
                ) : (
                  <TableCell>{row.value}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};

export default EventDetails;
